export type ShortQuote = {
    quote: string
    name: string
    company: string
}

export const shortQuotes: Array<ShortQuote> = [
    { quote: 'The forecast told us to stop dancing on TikTok. Best advice we have ever paid for.', name: 'Noor Shah', company: 'Kiln & Co.' },
    { quote: 'They answered our messages faster than our own team does.', name: 'Bram de Vries', company: 'Northline Bikes' },
    { quote: 'Monday reads are the only report I actually finish.', name: 'Carla Mendes', company: 'Casa Mar' },
    { quote: 'Our comments section turned into a fan club. Slightly alarming, very good.', name: 'Femi Adebayo', company: 'Adire House' },
    { quote: 'Growth paid for itself by month two. We did the maths twice.', name: 'Ana Lindgren', company: 'Kiez Coffee' },
    { quote: 'They told us when an idea flopped. Nobody had ever done that.', name: 'Raj Patel', company: 'Chai Theory' }
]
